<div class="card xyz-nested" xyz="fade big-5 delay-1 duration-2 origin-center"><div class="px-6"><div class="flex flex-col"><slot></slot></div></div></div>